import axios from "@/utils/request.js";
import qs from "qs"
const payment = (params) => axios.get('/api/web-basic/order/manager/page', {params})
const atoncePay = (params) => axios.get('/api/web-basic/pay/manager/page', {params})
const getShortMsgList = (params) => axios.get('/api/web-basic/sms/manager/page', {params})
const getGoodsList = (params) => axios.get('/api/web-basic/pay/goods/page', {params})
const trendChart = (params) => axios.get('/api/web-basic/pay/goods/page', {params})
const getOrder = (params) =>
    axios({
        url: '/api/web-basic/order/manager/order/detail',
        method: 'get',
        params
    })
export {
    payment,
    atoncePay,
    getShortMsgList,
    getGoodsList,
    trendChart,getOrder
  }